import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Card, CardContent } from "../components/ui/card";
import { Lock } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-sand">
      <Header />
      
      <main className="pt-24 pb-12 px-4 md:px-8 max-w-4xl mx-auto" data-testid="privacy-page">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-forest/10 mb-4">
            <Lock className="w-8 h-8 text-forest" />
          </div>
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4">
            Privacy Policy
          </h1>
          <p className="text-gray-600">Last updated: January 2026</p>
        </div>

        <Card className="border-stone-200">
          <CardContent className="p-8 prose prose-gray max-w-none">
            <h2 className="font-heading">1. Introduction</h2>
            <p>
              BQL - Best Quality Leads ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Platform.
            </p>

            <h2 className="font-heading">2. Information We Collect</h2>
            <h3>Personal Information</h3>
            <ul>
              <li>Name, email address, phone number</li>
              <li>Business name and service categories (for professionals)</li>
              <li>Location and service area</li>
              <li>Payment information (processed securely by third-party providers)</li>
              <li>Profile information and service descriptions</li>
            </ul>
            
            <h3>Automatically Collected Information</h3>
            <ul>
              <li>Device information and IP address</li>
              <li>Browser type and operating system</li>
              <li>Usage patterns and preferences</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h2 className="font-heading">3. How We Use Your Information</h2>
            <ul>
              <li>To provide and maintain our Platform</li>
              <li>To process transactions and subscriptions</li>
              <li>To connect customers with professionals</li>
              <li>To communicate with you about your account</li>
              <li>To improve our services and user experience</li>
              <li>To detect and prevent fraud or unauthorized access</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2 className="font-heading">4. Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Other Users:</strong> Job details are shared with professionals; professional profiles are visible to customers</li>
              <li><strong>Service Providers:</strong> Third parties who help us operate the Platform (payment processors, hosting services)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
            <p>We do not sell your personal information to third parties.</p>

            <h2 className="font-heading">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized 
              access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2 className="font-heading">6. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
            </ul>

            <h2 className="font-heading">7. Cookies</h2>
            <p>
              We use cookies and similar technologies to enhance your experience. You can control cookie settings through 
              your browser. For more information, see our Cookie Policy.
            </p>

            <h2 className="font-heading">8. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than your own. We ensure appropriate 
              safeguards are in place for such transfers.
            </p>

            <h2 className="font-heading">9. Children's Privacy</h2>
            <p>
              Our Platform is not intended for children under 18. We do not knowingly collect personal information from 
              children under 18.
            </p>

            <h2 className="font-heading">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="font-heading">11. Contact Us</h2>
            <p>
              For questions about this Privacy Policy or our data practices, contact us at:<br />
              Email: bestqualityleads@bqleadsprogigs.com<br />
              BQL - Best Quality Leads
            </p>

            <div className="mt-8 p-4 bg-sand rounded-xl">
              <p className="text-sm text-gray-600 mb-0">
                <strong>Your Privacy Matters.</strong> BQL - Best Quality Leads is committed to protecting your personal information 
                and being transparent about how we use it. If you have any concerns, please don't hesitate to contact us.
              </p>
            </div>
          </CardContent>
        </Card>
      </main>

      <Footer />
    </div>
  );
}
